var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row d-flex justify-content-center h6 mt-5"},[_c('div',{staticClass:"col-12 text-center"},[_c('a',{attrs:{"href":"#"}},[_vm._v("FAQs")]),_vm._v(" · "),_c('a',{attrs:{"href":"#"}},[_vm._v("Privacy & Terms")]),_vm._v(" · "),_c('a',{attrs:{"href":"#"}},[_vm._v("Docs")])])])
}]

export { render, staticRenderFns }